import { WHATSAPP_MANAGER_TEMPLATES_URL } from "@/lib/agent-tasks/whatsapp-manager"

export function WhatsappTemplateCreationGuide() {
  return (
    <div className="space-y-2 text-xs">
      <details className="text-muted-foreground">
        <summary className="cursor-pointer font-medium text-foreground">How to create a WhatsApp template</summary>
        <ol className="mt-2 list-decimal space-y-1 pl-5">
          <li>Open WhatsApp Manager and select the connected WhatsApp Business Account.</li>
          <li>Open Message templates and create a template. Choose its category and language.</li>
          <li>Write the message text and add examples for any numbered variables, then submit it for review.</li>
          <li>After approval, return here and refresh templates. Unavailable or rejected templates cannot be sent.</li>
        </ol>
        <p className="mt-2">Create templates in WhatsApp Manager, not the WhatsApp mobile app. Versafy cannot approve them.</p>
      </details>
      <a className="inline-block text-blue-600 underline" href={WHATSAPP_MANAGER_TEMPLATES_URL}
        target="_blank" rel="noopener noreferrer">Open WhatsApp Manager</a>
    </div>
  )
}
